var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdiYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8932 35.2087L35.787 28.2087L23.8932 21.2087V35.2087ZM50.3849 16.9387C50.6828 18.0354 50.8891 19.5054 51.0266 21.3721C51.187 23.2387 51.2557 24.8487 51.2557 26.2487L51.3932 28.2087C51.3932 33.3187 51.0266 37.0754 50.3849 39.4787C49.812 41.5787 48.4828 42.9321 46.4203 43.5154C45.3432 43.8187 43.3724 44.0287 40.3474 44.1687C37.3682 44.3321 34.6411 44.4021 32.1203 44.4021L28.4766 44.5421C18.8745 44.5421 12.8932 44.1687 10.5328 43.5154C8.47031 42.9321 7.14114 41.5787 6.56822 39.4787C6.27031 38.3821 6.06406 36.9121 5.92656 35.0454C5.76614 33.1787 5.69739 31.5687 5.69739 30.1687L5.55989 28.2087C5.55989 23.0987 5.92656 19.3421 6.56822 16.9387C7.14114 14.8387 8.47031 13.4854 10.5328 12.9021C11.6099 12.5987 13.5807 12.3887 16.6057 12.2487C19.5849 12.0854 22.312 12.0154 24.8328 12.0154L28.4766 11.8754C38.0786 11.8754 44.0599 12.2487 46.4203 12.9021C48.4828 13.4854 49.812 14.8387 50.3849 16.9387Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiYoutube);
export default __webpack_public_path__ + "static/media/mdi_youtube.9f2f88c5f7d85ee979cf0c3ccc9460cb.svg";
export { ForwardRef as ReactComponent };